import { DashboardCard, DashboardCardModel } from '@/entities/dashboard'
import FinanceIcon from '@/shared/assets/icons/dashboard/finance.svg?react'
import { BaseButton } from '@/shared/components'
import { formatDate } from '@/shared/lib/date'
import { useIsMobile } from '@/shared/utils'
import { Link } from 'react-router-dom'
import { TraderDashboardModel } from '../../model'
import { formatUSDT } from '@/shared/lib/currency/formatUSDT'

type Props = {
  statistic: TraderDashboardModel | undefined
  isLoading: boolean
}

export const TraderDashboardCards = ({ statistic, isLoading }: Props) => {
  const isMobile = useIsMobile()

  const date = statistic?.cryptoWithdrawCreatedAt
    ? formatDate(String(new Date(statistic?.cryptoWithdrawCreatedAt)), 'withoutSeconds')
    : 'Нет данных'

  const cards: DashboardCardModel[] = [
    {
      id: 0,
      title: isMobile ? 'Вывод средств' : 'Последний вывод средств',
      value: statistic?.cryptoWithdrawSentAmount
        ? formatUSDT(statistic?.cryptoWithdrawSentAmount ?? 0)
        : '',
      date,
      tooltip: 'Последний раз, когда средства были выведены с платформы.',
      button: (
        <Link to={'/finance'}>
          <BaseButton
            variant="outlined"
            padding="none"
            radius="lg"
            className="px-4 py-3 !ring-card-border dark:!ring-card-border-dark !text-main-black dark:!text-white whitespace-nowrap"
            icon={<FinanceIcon className="text-primary" />}
          >
            {isMobile ? 'В финансы' : 'Перейти в финансы'}
          </BaseButton>
        </Link>
      ),
    },
    {
      id: 1,
      title: 'Спорные транзакции',
      value: formatUSDT(statistic?.disput.amountFromMerchantUsdt ?? 0),
      transactionsCount: statistic?.disput.totalCount ?? 0,
      linkName: 'Показать все',
      link: '/orders',
    },
  ]

  return (
    <>
      {cards.map((card) => (
        <DashboardCard key={card.id} card={card} isLoading={isLoading} />
      ))}
    </>
  )
}
